(ns app.front.form.field-search
  (:require [app.domain.form.form-editor-util :as form-editor-util]
            [app.domain.form.schema :as form-schema]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.ui.typography :refer [p]]
            [app.front.util :as futil]
            [app.front.view.group.admin.form-schemas.subs :as form-schemas-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(defn new-search-event [group-id]
  [::search-by-term {:skip     0
                     :limit    100
                     :group-id group-id}])


(rf/reg-event-db ::form-field-search-toggle
  (fn [db [_ value selected-element-path available-field-types]]
    (let [available-types (if available-field-types
                            (->> available-field-types
                                 (map form-schema/field-type->data-type)
                                 distinct
                                 (filter some?))
                            [:text :number :date :time :boolean])]
      (-> db
          (assoc-in [::form-schemas-subs/form-schema :form-field-search-open?] value)
          (assoc ::selected-element-path selected-element-path)
          (assoc ::available-types available-types)
          (assoc-in [::data :search-term] "")
          (assoc-in [::data :type] (first available-types))
          (p/dissoc-in [::data :search-result])))))


(rf/reg-sub ::form-field-search-open?
  #(get-in % [::form-schemas-subs/form-schema :form-field-search-open?]))


(rf/reg-sub ::data
  #(-> % ::data))


(rf/reg-sub ::search-result
  :<- [::data]
  #(-> % :search-result))


(rf/reg-sub ::search-term
  :<- [::data]
  #(-> % :search-term))


(rf/reg-sub ::type
  :<- [::data]
  #(-> % :type))


(rf/reg-sub ::selected-field
  :<- [::data]
  #(-> % :selected-field))


(rf/reg-sub ::available-types
  #(-> % ::available-types))


(rf/reg-sub ::search-in-progress?
  :<- [::data]
  #(-> % :search-in-progress? boolean))


(defn format-search-request [db]
  (p/assoc-if {}
              :search-term (-> db ::data :search-term)
              :type (-> db ::data :type)
              :authority-group-id (-> db ::data :group-id)
              :skip (-> db ::data :skip)
              :limit (-> db ::data :limit)))




(rf/reg-event-db ::select-field
  (fn [db [_ field]]
    (assoc-in db [::data :selected-field] field)))


(rf/reg-event-fx ::term-search-event
  (fn [{:keys [db]} [_ term group-id]]
    {:dispatch-debounce [{:id      ::do-term-field-search
                          :timeout 500
                          :action  :dispatch
                          :event   (new-search-event group-id)}]
     :db                (if (str/blank? term)
                          (p/dissoc-in db [::data :search-term])
                          (assoc-in db [::data :search-term] term))}))


(rf/reg-event-fx ::type-search-event
  (fn [{:keys [db]} [_ type group-id]]
    {:dispatch (new-search-event group-id)
     :db       (assoc-in db [::data :type] type)}))


(rf/reg-event-fx ::search-by-term
  (fn [{:keys [db]} [_ {:keys [skip limit group-id]}]]
    (let [search-term (-> db ::data :search-term)
          term-ok?    (some-> search-term str/trim count (> 2))
          new-db      (cond-> (assoc-in db [::data :search-in-progress?] term-ok?)
                        skip (assoc-in [::data :skip] skip)
                        limit (assoc-in [::data :limit] limit)
                        true (assoc-in [::data :group-id] group-id))]
      (cond-> {:db new-db}
        term-ok? (assoc :comm/command {:command          :form/find-form-field-defs
                                       :data             (format-search-request new-db)
                                       :on-success       [::search.success]
                                       :finally-dispatch [::search.done]})))))


(defn field-matches-and-only-local? [term type omitted-field-keys {:keys [field label description tag]}]
  (and (->> field (contains? omitted-field-keys) not)
       (-> tag form-schema/field-type->data-type (= type))
       (or (some-> label (str/includes? term))
           (some-> description (str/includes? term)))))


(defn field->result [type {:keys [field label form-label] :as field-el}]
  (merge {:id          (str "local-" (name field))
          :labels      [label]
          :type        type
          :form-labels [form-label]}
         (select-keys field-el [:field :description :tag :unit])))


(defn search-locally
  "Add unsaved fields that are not in the ES search results into the full results."
  [db es-result]
  (let [term          (-> db ::data :search-term)
        type          (-> db ::data :type)
        es-field-keys (->> es-result
                           :results
                           (map :field)
                           set)
        schema        (form-editor-util/map-presentation->schema-data (get-in db form-schemas-subs/db-path-to-editor-data))
        fields        (form-schema/form-schema->field-list [schema] (get-in db (concat form-schemas-subs/db-path-to-editor-data [0 :attributes :label])))
        hits          (filter (partial field-matches-and-only-local? term type es-field-keys) fields)]
    (if (seq hits)
      (-> es-result
          (update :total-count #(+ % (count hits)))
          (update :results #(concat (map (partial field->result type) hits) %)))
      es-result)))


(rf/reg-event-db ::search.success
  (fn [db [_ _ result]]
    (let [full-result (search-locally db result)]
      (-> db
          (assoc-in [::data :search-result] full-result)
          (p/dissoc-in [::data :selected-field])))))


(rf/reg-event-db ::search.done
  #(assoc-in % [::data :search-in-progress?] false))


(rf/reg-event-fx ::confirm-selected-field
  (fn [{:keys [db]} _]
    {:dispatch-n [[::form-schemas-subs/set-selected-existing-field
                   (-> db ::data :selected-field)
                   (-> db ::selected-element-path)]
                  [::form-field-search-toggle false]]}))


(defn field-details [tr field]
  [:div.border-b.border-solid.border-ui-gray.bg-ui-white
   [:div.grid.grid-cols-3.ml-8.py-2
    [:label.bx--label.bold (tr [:form.schema/field-key])]
    [:div.col-span-2 (:field field)]
    [:label.bx--label.bold (tr [:form.schema/used-in-forms])]
    [:div.col-span-2 (str/join ", " (:form-labels field))]]])


(defn result-table [tr]
  (let [fields (:results (<sub [::search-result]))]
    (if (seq fields)
      (let [selected-field (<sub [::selected-field])]
        #_{:clj-kondo/ignore [:deprecated-var]}
        [ui-table/responsive-table {:tr                    tr
                                    :class                 "my-4 w-full max-h-96 overflow-auto"
                                    :expandable?           true
                                    :header-class-override "py-2 bg-ui-gray font-bold"
                                    :row-class-override    "py-1 lg:items-center border-b border-solid border-ui-gray"}
         [{:title (tr [:form.schema/label])
           :flex  4}
          {:title (tr [:form.schema/description])
           :flex  4}
          {:title (tr [:form.schema/unit])
           :flex  1}]
         (->> fields
              (map (fn [{:keys [id labels description unit] :as field-def}]
                     {:key              id
                      :opts             {:class    (concat ["my-3 mb-4"]
                                                           (when (= (:id selected-field) id) ["border-2 border-solid border-ui-blue"]))
                                         :on-click #(>evt [::select-field field-def])}
                      :expanded-content [field-details
                                         tr
                                         field-def]
                      :cols             [{:content (str/join ", " labels)
                                          :opts    {:class "leading-tight"}}
                                         {:content description
                                          :opts    {:class "leading-tight"}}
                                         {:content unit
                                          :opts    {:class "leading-tight"}}]}))
              doall)])
      [p "mb-4" (tr [:form.schema/no-search-results])])))


(defn form-field-search-view [{:keys [tr]}]
  (let [in-progress?    (<sub [::search-in-progress?])
        group-id        (<sub [::form-schemas-subs/group-id-from-route])
        selected-field  (<sub [::selected-field])
        available-types (<sub [::available-types])
        result          (<sub [::search-result])]
    [:div.flex.flex-col
     [:h3.font-bold.text-base.flex-1.mb-6 (tr [:form.schema/select-existing-field])]
     [:div
      [:fieldset.bx--grid.ml-0
       [:div.bx--row.mb-2
        [:div.bx--label (tr [:form.schema/search-term])]
        [ui/search {:id                      "form-field-term-search"
                    :container-class         "bx--col pl-0"
                    :label-text              (tr [:dashboard-search/search])
                    :placeholder             (tr [:dashboard-search/search-placeholder])
                    :close-button-label-text (tr [:search/empty])
                    :value                   (<sub [::search-term])
                    :on-change               #(rf/dispatch-sync [::term-search-event (-> % futil/tval str) group-id])
                    :search-in-progress?     in-progress?
                    :loading-style           {:top "3px"}
                    :loading-text            (tr [:search/loading])
                    :clear-fn                #(>evt [::term-search-event "" group-id])
                    :light                   true}]]
       [:div.bx--row.mb-6
        [ui-select/select {:id           "type-select"
                           :label-text   (tr [:form.schema/data-type])
                           :allow-empty? false
                           :select-text  (tr [:dashboard-search/select-filter])
                           :values       available-types
                           :on-change    #(>evt [::type-search-event % group-id])
                           :value        (<sub [::type])
                           :val->str     name}]]
       [:div.bx--row
        [:h5.font-bold (cond-> (tr [:form.schema/search-results])
                         result (str " (" (:total-count result) ")"))]]
       [:div.bx--row
        (result-table tr)]
       [:div.bx--row.flex.justify-end
        [cc/button
         {:kind       :tertiary
          :class-name "mr-2"
          :on-click   #(>evt [::form-field-search-toggle false])}
         (tr [:cancel])]
        [cc/button
         {:kind     :primary
          :data-cy  "use-selected-btn"
          :on-click #(>evt [::confirm-selected-field])
          :disabled (nil? selected-field)}
         (tr [:form.schema/use-selected-field])]]]]]))
